export default "__VITE_ASSET__DYha5YgA__"